import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 grid-cols-2 xl:grid-cols-4 gap-y-8 gap-x-4 mb-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-200 font-medium mb-4" }, " Best Performer (24h) ", -1)
const _hoisted_3 = { class: "font-medium truncate flex items-center mt-2 text-gray-200" }
const _hoisted_4 = { class: "text-xl font-medium mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-200 font-medium mb-4" }, " Top Earner (24h) ", -1)
const _hoisted_6 = { class: "font-medium truncate flex items-center mt-2 text-gray-200" }
const _hoisted_7 = { class: "text-xl font-medium mt-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-200 text-sm" }, " In swap fees ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-200 font-medium mb-4" }, " Highest Volume (24h) ", -1)
const _hoisted_10 = { class: "font-medium truncate flex items-center mt-2 text-gray-200" }
const _hoisted_11 = { class: "text-xl font-medium mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-200 text-sm" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-200 font-medium mb-4" }, " Worst Performer (24h) ", -1)
const _hoisted_14 = { class: "font-medium truncate flex items-center mt-2 text-gray-200" }
const _hoisted_15 = { class: "text-xl font-medium mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
          return _createVNode(_component_BalLoadingBlock, {
            key: n,
            class: "h-52"
          })
        }), 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.topPerformer)
            ? (_openBlock(), _createBlock(_component_BalCard, {
                key: 0,
                class: "col col-span-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_BalAssetSet, {
                    addresses: _ctx.topPerformer.tokens.map(token => token.address),
                    size: 40,
                    width: 150
                  }, null, 8, ["addresses"]),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.topPerformer.name), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.formatPriceChange(_ctx.topPerformer.priceChange)) + " ", 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass([
            ' text-sm',
            _ctx.topPerformerIsNegative ? 'text-red-500' : 'text-white'
          ])
                  }, _toDisplayString(_ctx.formatPriceChangePercent(_ctx.topPerformer.priceChangePercent)), 3)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.topPerformer)
            ? (_openBlock(), _createBlock(_component_BalCard, {
                key: 1,
                class: "col col-span-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_BalAssetSet, {
                    addresses: _ctx.topEarner.tokens.map(token => token.address),
                    size: 40,
                    width: 150
                  }, null, 8, ["addresses"]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.topEarner.name), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.fNum(_ctx.topEarner.myFees, 'usd')) + " ", 1)
                  ]),
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.highestVolume)
            ? (_openBlock(), _createBlock(_component_BalCard, {
                key: 2,
                class: "col col-span-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createVNode(_component_BalAssetSet, {
                    addresses: _ctx.highestVolume.tokens.map(token => token.address),
                    size: 40,
                    width: 150
                  }, null, 8, ["addresses"]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.highestVolume.name), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.fNum(_ctx.highestVolume.swapVolume, 'usd')), 1),
                  _hoisted_12
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.worstPerformer)
            ? (_openBlock(), _createBlock(_component_BalCard, {
                key: 3,
                class: "col col-span-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createVNode(_component_BalAssetSet, {
                    addresses: _ctx.worstPerformer.tokens.map(token => token.address),
                    size: 42,
                    width: 150
                  }, null, 8, ["addresses"]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.worstPerformer.name), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.formatPriceChange(_ctx.worstPerformer.priceChange)), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass([
            ' text-sm',
            _ctx.worstPerformerIsNegative ? 'text-red-500' : 'text-white'
          ])
                  }, _toDisplayString(_ctx.formatPriceChangePercent(_ctx.worstPerformer.priceChangePercent)), 3)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}